import React, { useEffect, useState } from 'react';

import CustomLoader from '@/components/common/CustomLoader';
import { LoadingContext } from '@/context/LoadingContext';

export const LoadingProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (loading) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }

        return () => {
            document.body.style.overflow = '';
        };
    }, [loading]);

    return (
        <LoadingContext.Provider value={{ loading, setLoading }}>
            {loading && <CustomLoader />}
            {children}
        </LoadingContext.Provider>
    );
};
